import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ISettingsTable } from 'src/app/@amiga-pyme/interfaces/table.interface';
import { TableActionsTemplate } from 'src/app/@amiga-pyme/table-actions/templates/table-actions.template';
import {
  INVOICESTATUS_ID,
  ORDERSTATUS_ID,
  RECEPTIONSTATUS_ID
} from '../../purchase-order/purchase-order.interface';
import { IPurchaseOrderReception } from '../purchase-order-reception.interface';
import { PurchaseOrderReceptionService } from '../purchase-order-reception.service';

@Component({
  templateUrl: './purchase-order-reception-detail.component.html',
  selector: 'pg-purchase-order-reception-detail'
})
export class PurchaseOrderReceptionDetailComponent extends TableActionsTemplate {
  visible = true;
  @Input() dataDocument: any;
  @Output() onHideData = new EventEmitter<boolean>();
  tableDetailSettings: ISettingsTable;
  detailPurchaseOrder;
  prueba: any[];
  precioTotal = 0;
  quantity = 0;
  quantityReceived = 0;
  constructor(private serviceBase: PurchaseOrderReceptionService) {
    super('', serviceBase);
  }

  ngOnInit(): void {
    this.table.settings = {
      title: 'Detalle de los Productos',
      columns: [
        { header: 'Producto', field: 'name' },
        { header: 'Cantidad', field: 'quantity' },
        { header: 'Lote', field: 'lot' },
        { header: 'Fecha de Vencimiento', field: 'expAt', pipe: 'Date' }
      ]
    };
    this.initSubscriptions$();
    this.visible = true;
  }
  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IPurchaseOrderReception[]) => {
        const id = data.findIndex(
          (item) => item['id'] == this.dataDocument['id']
        );
        this.table.data = data[id]['products'];
        this.detailPurchaseOrder = data[id];
        // this.parseToTable(this.detailPurchaseOrder);
        this.calcularCantidadRecibida();
      });
  }
  calcularCantidadRecibida() {
    this.quantity = 0;
    for (const item of this.detailPurchaseOrder['products']) {
      this.quantity += Number(item['quantity']);
    }
  }

  // parseToTable(data) {
  //   data['orderStatusName'] = ORDERSTATUS_ID[data.orderStatusId];
  //   data['invoiceStatusName'] = RECEPTIONSTATUS_ID[data.invoiceStatusId];
  //   data['receptionStatusName'] = INVOICESTATUS_ID[data.receptionStatusId];
  //   this.detailPurchaseOrder = data;
  // }

  onHideDataDialog() {
    this.visible = false;
    this.onHideData.emit();
  }
}
